import { ModalHandler } from '@app-velocity/ui';

import { ShareScenarioModalContent } from './components/ShareScenarioModalContent';

//duplicate of apps/main-front?
export const ShareScenarioModal = () => {
  return (
    <ModalHandler channel="prototypes" id="share-scenario">
      <ShareScenarioModalContent />
    </ModalHandler>
  );
};
